const Colors = [
  {
    id: 1,
    borderLeft: "solid 5px #b4b3ff",
    backgroundColor: "#fafaff",
  },
  {
    id: 2,
    borderLeft: "solid 5px #ffc48b",
    backgroundColor: "#fff6ee",
  },
  {
    id: 3,
    borderLeft: "solid 5px #ffb3c0",
    backgroundColor: "#fff0f3",
  },
  {
    id: 4,
    borderLeft: "solid 5px #dfb3ff",
    backgroundColor: "#fdf5ff",
  },
  {
    id: 5,
    borderLeft: "solid 5px #378E8C",
    backgroundColor: "#f1fffe",
  },
  {
    id: 6,
    borderLeft: "solid 5px #fc97d4",
    backgroundColor: "#ffedf9",
  },
];
export default Colors;
